import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
    selector: 'app-homepage',
    standalone: false,
    template: `Bitte warten Sie einen Moment...`
})
export class HomepageComponent implements OnInit {

    constructor(
        protected router: Router,
        protected oidcSecurityService: OidcSecurityService
    ) { }

    ngOnInit(): void {
        setTimeout(() => {
            this.oidcSecurityService.userData$.subscribe({
                next: (userData) => {
                    if (userData && userData.userData) {
                        if ((this.router.url === '/' || this.router.url.startsWith('/?code=')) && userData.userData.role && userData.userData.role.some((role: string) => role.includes('adminpanel'))) {
                            this.router.navigate(['/pages/dashboard']);
                        }

                        if ((this.router.url === '/' || this.router.url.startsWith('/?code=')) && !userData.userData.role.some((role: string) => role.includes('adminpanel'))) {
                            console.log('Unauthorized, redirecting to /unauthorized');
                            this.router.navigate(['/unauthorized']);
                        }
                    }
                }
            });
        }, 500);
    }
}